/**
 * Application width contract: the page must leave room for both navigation
 * and answers. Keep route shells, previews and loading states on these shared
 * classes; a narrower Page default would silently squeeze the section editor.
 * Prose controls its own line length, independently of the workspace width.
 */
export const applicationPageClassName = "max-w-7xl";
export const applicationContentClassName = "mx-auto w-full min-w-0 max-w-5xl";
export const applicationSectionLayoutClassName = `mx-auto grid w-full min-w-0 ${applicationPageClassName} gap-4 lg:grid-cols-[14rem_minmax(0,1fr)] lg:gap-6`;
